module.exports = __webpack_public_path__ + "media/public/img/landing_page/GettinLocal-1-16d6adfbbb57f9de322def4506f75f1f.png";